<script>
import AcceptTermsCheckbox from "@/components/AcceptTermsCheckbox.vue"; // justera sökvägen vid behov
import api from "../axios.js";
import { useI18n } from "vue-i18n";
import { mapActions } from "vuex";
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

export default {
  components: {
    AcceptTermsCheckbox,
  },
  data() {
    return {
      email: "",
      password: "",
      error: "",
      acceptedTerms: false,
    };
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  methods: {
    ...mapActions({
      vuexLogin: "login",
    }),
    async handleLogin() {
      if (!this.acceptedTerms) {
        this.error = `${this.t("errors.acceptTermsLogin")}.`;
        return;
      }

      try {
        const res = await api.post(`${apiBaseUrl}/auth/login`, {
          email: this.email,
          password: this.password,
          acceptedTerms: this.acceptedTerms,
        });

        await this.vuexLogin({
          token: res.data.token,
          user: res.data.user,
        });

        api.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${res.data.token}`;

        let studentProfile = null;

        if (["student", "admin"].includes(res.data.user.role)) {
          const response = await api.get(`${apiBaseUrl}/students/me`);
          studentProfile = response.data;
        }

        const combinedUser = {
          ...(studentProfile || {}),
          role: res.data.user.role,
        };

        this.$store.commit("setUser", combinedUser);

        this.$router.push("/");
      } catch (err) {
        this.error = err.response?.data?.message || "Inloggning misslyckades";
      }
    },
  },
};
</script>

<template>
  <v-container class="mt-16">
    <h2>{{ t("login.login") }}</h2>
    <v-form @submit.prevent="handleLogin">
      <v-text-field
        v-model="email"
        type="email"
        :placeholder="t('profile.email')"
        required
      />
      <v-text-field
        v-model="password"
        type="password"
        :placeholder="t('login.password')"
        required
      />

      <AcceptTermsCheckbox v-model="acceptedTerms" color="primary" />

      <v-btn type="submit">{{ t("login.login") }}</v-btn>
    </v-form>

    <p v-if="error" style="color: red">{{ error }}</p>
    <p class="mt-4">
      {{ t("login.accountNotExist") }}
      <router-link
        to="/register"
        style="color: blue; cursor: pointer; text-decoration: underline"
      >
        {{ t("login.registerHere") }}
      </router-link>
    </p>
  </v-container>
</template>
